import { useLazyQuery } from "@apollo/client/react";
import { MenuItem } from '@mui/material';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { TextInput } from '../../../components/textInput/TextInput';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SearchIcon from '@mui/icons-material/Search';
import { Box, FormControl, Grid, InputAdornment, InputLabel, OutlinedInput, Select, Stack, TextField } from '@mui/material';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useForm } from '../../../components/hooks/useForm';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

import { GET_PRODUCTS_BY_FILTERS } from '../../../data/graphQL/queries/Insumos/queries';
import './tabCategorizacion.scss';

export default function TabCategorizacion({ insumo, setInsumo,
  idTipoInsumo,
  tiposAcceso,
  listaTM, setListaTM,
  listaProductosCaja, setListaProductosCaja,
  listaAccesos, setListaAccesos
}) {

  let { IdEleccion } = insumo;

  const theme = useTheme();

  const [openDlgTM, setOpenDlgTM] = useState(false);
  const [tecnologiasMedicas, setTecnologiasMedicas] = useState([]);
  const [tecnologiasMedicasOriginal, setTecnologiasMedicasOriginal] = useState([]);

  const [openDlgProducto, setOpenDlgProducto] = useState(false);
  const [productos, setProductos] = useState([]);
  const [productosOriginal, setProductosOriginal] = useState([]);
  const txtFiltroProducto = useRef(null);
  const [loadingBuscarProveedores, setLoadingBuscarProveedores] = useState(false);
  const [loadingBuscarProducto, setLoadingBuscarProducto] = useState(false);


  const [esNutricion, setEsNutricion] = useState(false);
  const [esCaja, setEsCaja] = useState(false);

  const [idInsumoCaja, setIdInsumoCaja] = useState(0);

  const txtFiltroTM = useRef(null);
  const [loadingBuscarTM, setLoadingBuscarTM] = useState(false);
  const [rowSelectionModelDispo, setRowSelectionModelDispo] = useState([]);

  useEffect(() => {

    if (idTipoInsumo == 1) {
      setEsNutricion(true);
      limpiarCaja();
    } else
    if (idTipoInsumo == 2) {
      setEsCaja(true);
      limpiarNutricion();
    } else
    {
      setEsNutricion(false);
      setEsCaja(false);
      limpiarNutricion();
      limpiarCaja();
    }

    if (tiposAcceso.length > 0 && listaAccesos.length > 0) {
      setFormValues(
        {
          ...formValues,
          ComboTiposAcceso: listaAccesos.map((x) => x.nombre)
        });
    }

    getProductosTM({ variables: { idTipoInsumo: 3, descripcion: '' } });
    getProductosDescartables({ variables: { idTipoInsumo: 4, descripcion: '' } });

  }, []);

  const [formValues, formHandle, reset, setFormValues] = useForm({
    IdEleccion: IdEleccion,
    ComboTiposAcceso: [],
    Cantidad: '',
    Producto: '',
    DescripcionProducto: ''
  });

  const [getProductosTM, { data: dataTM }] = useLazyQuery(GET_PRODUCTS_BY_FILTERS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTM) return;
    if (dataTM.productoByFilters.success) {
      setTecnologiasMedicas(dataTM.productoByFilters.valorEsperado);
      setTecnologiasMedicasOriginal(dataTM.productoByFilters.valorEsperado);
    };
  }, [dataTM]);

  const [getProductosDescartables, { data: dataProducto }] = useLazyQuery(GET_PRODUCTS_BY_FILTERS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProducto) return;
    if (dataProducto.productoByFilters.success) {
      setProductos(dataProducto.productoByFilters.valorEsperado);
      setProductosOriginal(dataProducto.productoByFilters.valorEsperado);
    };
  }, [dataProducto]);  

  const limpiarNutricion = () => {
    setFormValues({
      ...formValues,
      IdEleccion: 0
    });
  };

  const limpiarCaja = () => {
    setFormValues({
      ...formValues,
      Cantidad: '',
      Producto: '',
      DescripcionProducto: ''
    });
  };

  const handleChangeComboTiposAcceso = (event) => {
    const { target: { value } } = event;

    setFormValues(
      {
        ...formValues,
        ComboTiposAcceso: typeof value === 'string' ? value.split(',') : value
      });
  };

  // handles de Dialog TM
  const handleSearchTMs = () => {
    setOpenDlgTM(true);
    setLoadingBuscarTM(true);

    mergeSelectedTM();
  };

  const mergeSelectedTM = () => {
    let lista = tecnologiasMedicasOriginal.filter((x) => {
      let resultado = listaTM.find((y) => {
        return y.idInsumo == x.idInsumo;
      });
      return resultado == undefined;
    });

    setTecnologiasMedicas(lista);
  };

  const handleSearchTM = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltroTM.current.value != "") {
      setTecnologiasMedicas(tecnologiasMedicas.filter((tecnologiasMedicas) => {
        const insumoBuscar = tecnologiasMedicas.idInsumo.toLowerCase();
        const descripcionBuscar = tecnologiasMedicas.descripcion.toLowerCase();

        const inputBuscar = txtFiltroTM.current.value.toLowerCase();
        return (
          insumoBuscar.includes(inputBuscar) ||
          descripcionBuscar.includes(inputBuscar));

      }
      ));
    } else {
      //setTecnologiasMedicas(tecnologiasMedicasOriginal);
      mergeSelectedTM();
    }
  };

  const handleCleanTM = () => {
    txtFiltroTM.current.value = "";
    handleSearchTM();
    txtFiltroTM.current.focus();
  };

  const onRowsSelectionHandlerDispo = (ids) => {
    setRowSelectionModelDispo(ids);
  };

  const handleAceptarDlgNuevos = () => {
    if (rowSelectionModelDispo.length > 0) {
      let idsInsumo = [];
      // verifico antes de agregar que no esté incluido ya el código
      rowSelectionModelDispo.map((index) => {
        const nodo = idsInsumo.filter((c) => c == tecnologiasMedicas[index - 1].idInsumo);
        idsInsumo.push(tecnologiasMedicas[index - 1].idInsumo);
      });


      let lista = tecnologiasMedicas.filter((x) => {
        let resultado = idsInsumo.find((y) => {
          return y == x.idInsumo;
        });
        return resultado != undefined;
      }).map((item) => {
        let obj = {
          idInsumoTM: item.idInsumoN,
          idInsumo: item.idInsumo,
          descripcion: item.descripcion
        };

        return obj;
      });

      if (listaTM.length <= 0) {
        setListaTM(lista);
      } else
      {
        lista.forEach((element) => {
          setListaTM((current) => [...current, element]);
        });
      }

      setOpenDlgTM(false);
      setLoadingBuscarTM(false);

    } else {
      toast.error("Debe seleccionar al menos un producto.");
    }
  };

  const handleCloseDlgTM = () => {
    setOpenDlgTM(false);
    setLoadingBuscarTM(false);
  };

  const handleDeleteTM = (row) => {
    //let listado = tecnologiasMedicasSelected.filter(x => x.idInsumo != row.idInsumo);
    let listado = listaTM.filter((x) => x.idInsumo != row.idInsumo);

    setListaTM((current) => [...listado]);
  };

  // handles de Dialog Producto
  const handleSearchProductos = () => {
    setOpenDlgProducto(true);
    setLoadingBuscarProducto(true);

    mergeSelectedProducto();
  };

  const mergeSelectedProducto = () => {
    let lista = productosOriginal.filter((x) => {
      let resultado = listaProductosCaja.find((y) => {
        return y.id == x.idInsumo;
      });
      return resultado == undefined;
    });

    setProductos(lista);
  };

  const handleSearchProducto = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltroProducto.current.value != "") {
      setProductos(productos.filter((productos) => {
        const insumoBuscar = productos.idInsumo.toLowerCase();
        const descripcionBuscar = productos.descripcion.toLowerCase();

        const inputBuscar = txtFiltroProducto.current.value.toLowerCase();
        return (
          insumoBuscar.includes(inputBuscar) ||
          descripcionBuscar.includes(inputBuscar));

      }
      ));
    } else {
      mergeSelectedProducto();
    }
  };

  const handleCleanProducto = () => {
    txtFiltroProducto.current.value = "";
    handleSearchProducto();
    txtFiltroProducto.current.focus();
  };

  const handleRowClickProducto = (params) => {
    setLoadingBuscarProducto(false);
    setOpenDlgProducto(false);

    const descripcionProducto = params.row.descripcion + ' (' + params.row.idInsumo + ')';

    setIdInsumoCaja(params.row.idInsumoN);

    setFormValues({
      ...formValues,
      Producto: params.row.idInsumo,
      DescripcionProducto: descripcionProducto
    });
  };

  const handleCloseDlgProducto = () => {
    setOpenDlgProducto(false);
    setLoadingBuscarProducto(false);
  };

  const handleDeleteProducto = (row) => {
    let listado = listaProductosCaja.filter((x) => x.id != row.id);

    setListaProductosCaja((current) => [...listado]);
  };

  const handleAddProducto = () => {

    if (isValidProducto()) {
      const item = {
        id: formValues.Producto,
        idInsumo: insumo.IdInsumo == '' ? 0 : insumo.IdInsumo,
        idInsumoCaja: idInsumoCaja,
        cantidad: parseInt(formValues.Cantidad),
        descripcion: formValues.DescripcionProducto
      };

      setListaProductosCaja((current) => [...current, item]);

      limpiarProducto();
    }
  };

  const isValidProducto = () => {
    if (formValues.DescripcionProducto.length <= 0) {
      toast.error('Debe ingresar el Producto.');
      return false;
    }
    if (formValues.Cantidad.length <= 0) {
      toast.error('Debe ingresar el campo Cantidad.');
      return false;
    }

    return true;
  };

  const limpiarProducto = () => {
    setFormValues({
      ...formValues,
      Producto: '',
      DescripcionProducto: '',
      Cantidad: ''
    });
  };

  // generate colums grillas
  const initialColumnsTM = [
  {
    field: 'idInsumo',
    headerName: 'Codigo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripcion'
  }];

  const columnsTM = generateColumnsDefaultConfiguration(initialColumnsTM);

  const initialColumnsTMSelected = [
  {
    field: 'idInsumo',
    headerName: 'Codigo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripcion'
  },
  {
    headerName: '',
    field: 'action',
    renderCell: (params) => {
      const row = params.row;
      return (
        <>
                        <>
                            <DeleteOutlineIcon
              className='edit-icon'
              titleAccess='Eliminar'
              onClick={() => handleDeleteTM(params.row)} />
            
                        </>
                    </>);

    }
  }];

  const columnsTMSelected = generateColumnsDefaultConfiguration(initialColumnsTMSelected);

  const initialColumnsProducto = [
  {
    field: 'idInsumo',
    headerName: 'Codigo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripcion'
  }];

  const columnsProducto = generateColumnsDefaultConfiguration(initialColumnsProducto);

  const initialColumnsProductoSelected = [
  {
    field: 'id',
    headerName: 'Codigo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripcion'
  },
  {
    field: 'cantidad',
    headerName: 'Cantidad'
  },
  {
    headerName: '',
    field: 'action',
    flex: 0.02,
    renderCell: (params) => {
      const row = params.row;
      return (
        <>
                        <DeleteOutlineIcon
            className='edit-icon'
            titleAccess='Eliminar'
            onClick={() => handleDeleteProducto(params.row)} />
          
                    </>);

    }
  }];

  const columnsProductoSelected = generateColumnsDefaultConfiguration(initialColumnsProductoSelected);


  function getStyles(name, personName, theme) {
    return {
      fontWeight:
      personName.indexOf(name) === -1 ?
      theme.typography.fontWeightRegular :
      theme.typography.fontWeightMedium
    };
  }

  return (
    <>
            <div className='insumos-tab-categorizacion'>
                <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          spacing={2}>
          
                    <Grid size={{ xs: 12 }}>
                        <span className='span-row'>Nutrición</span>
                    </Grid>
                    <Grid size={{ xs: 2 }}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                                <InputLabel id="select-eleccion">Eleccion</InputLabel>
                                <Select
                  labelId="select-eleccion"
                  id="Eleccion"
                  value={formValues.IdEleccion}
                  label="Eleccion"
                  onChange={(e) => {
                    setFormValues(
                      {
                        ...formValues,
                        IdEleccion: e.target.value
                      });
                    setInsumo((prevState) => {
                      return {
                        ...prevState,
                        datosCategorizacion: {
                          ...insumo,
                          IdEleccion: e.target.value
                        }
                      };
                    });
                  }
                  }
                  disabled={!esNutricion}>
                  
                                    <MenuItem value={0}> NO </MenuItem>
                                    <MenuItem value={1}> 1ra </MenuItem>
                                    <MenuItem value={2}> 2da </MenuItem>
                                    <MenuItem value={3}> 3ra </MenuItem>
                                    <MenuItem value={4}> 4ta </MenuItem>
                                    <MenuItem value={5}> 5ta </MenuItem>
                                    <MenuItem value={6}> 6ta </MenuItem>
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid
          marginTop={1}
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}
          spacing={2}>
          
                    <Grid size={{ xs: 12 }}>
                        <span className='span-row'>Caja</span>
                    </Grid>
                    <Grid sx={{ boxSizing: 'border-box', width: '100%' }} size={{ xs: 4 }}>
                        <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                            <InputLabel id="multiple-chip-label" sx={{ backgroundColor: 'white', width: 100 }}>Tipo Acceso</InputLabel>
                            <Select
                labelId="multiple-chip-label"
                id="multiple-chip"
                multiple
                value={formValues.ComboTiposAcceso}
                onChange={handleChangeComboTiposAcceso}
                onBlur={(e) => {
                  if (formValues.ComboTiposAcceso.length > 0) {
                    let lista = tiposAcceso.filter((x) => {
                      let resultado = formValues.ComboTiposAcceso.find((y) => {
                        return y == x.nombre;
                      });
                      return resultado != undefined;
                    });

                    setListaAccesos(lista);
                  } else
                  {
                    setListaAccesos([]);
                  }
                }
                }
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) =>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) =>
                  <Chip key={value} label={value} />
                  )}
                                    </Box>
                }
                disabled={!esCaja}>
                
                                {tiposAcceso.map((tipoAcceso) =>
                <MenuItem
                  key={tipoAcceso.idTipoAcceso}
                  value={tipoAcceso.nombre}
                  style={getStyles(tipoAcceso, formValues.ComboTiposAcceso, theme)}>
                  
                                        {tipoAcceso.nombre}
                                    </MenuItem>
                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid sx={{ width: '100%' }} size={{ xs: 2.5 }}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <CustomButton
                disabled={!esCaja}
                onClick={handleSearchTMs}
                size='small'
                sx={{ backgroundColor: '#2D72B4' }}
                title='Agregar nuevo Insumo'
                variant='contained'>
                
                                Buscar TM
                            </CustomButton>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 1.5 }}></Grid>
                </Grid>
                <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}>
          
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 12 }}>
                        <DataGridGenerico
              columns={columnsTMSelected}
              fileNameExport='DatosProducto'
              rows={listaTM}
              toolbar={false}
              totalCount={listaTM.length} />
            
                    </Grid>
                </Grid>
                <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}>
          
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 4 }}>
                        <TextInput
              label='Buscar Producto'
              searchIcon
              placeholder='Buscar Producto'
              onClick={esCaja ? handleSearchProductos : null}
              value={formValues.DescripcionProducto}
              disabled={!esCaja} />
            
                    </Grid>
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 1.6 }}>
                        <TextField
              className="input"
              label="Cantidad"
              name="Cantidad"
              onChange={(e) => {
                const valor = e.target.value;
                if (valor >= 0) {
                  setFormValues(
                    {
                      ...formValues,
                      Cantidad: valor
                    });
                }
              }
              }
              size="small"
              type="number"
              InputProps={{ inputProps: { min: 0 } }}
              value={formValues.Cantidad}
              variant="outlined"
              disabled={!esCaja} />
            
                    </Grid>
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 0.8 }}>
                        <CustomButton
              style={{ lineHeight: '28px' }}
              variant='contained'
              size='small'
              sx={{ backgroundColor: '#2D72B4' }}
              onClick={handleAddProducto}
              disabled={!esCaja}>
              
                            Agregar
                        </CustomButton>
                    </Grid>
                    <Grid size={{ xs: 1.2 }}></Grid>
                </Grid>
                <Grid
          container
          justifyContent={'space-between'}
          columns={{
            xs: 2,
            md: 8
          }}>
          
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 12 }}>
                        <DataGridGenerico
              columns={columnsProductoSelected}
              fileNameExport='DatosProducto'
              rows={listaProductosCaja}
              toolbar={false}
              totalCount={listaProductosCaja.length} />
            
                    </Grid>
                </Grid>
            </div>

            <CustomDialog
        maxWidth="lg"
        fullWidth="true"
        open={openDlgTM}
        title={'Selecciona Tecnología Médica'}
        onCancel={handleCloseDlgTM}
        cancelText='Cerrar'
        onAccept={handleAceptarDlgNuevos}>
        
                <div style={{ display: 'flex', width: '100%' }}>
                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <div style={{ display: 'flex', width: '100%' }}>
                            <TextField
              //className="input-300"
              label="Filtrar"
              name="txtFiltroTM"
              size="small"
              type="text"
              variant="outlined"
              inputRef={txtFiltroTM}
              onKeyUp={handleSearchTM}
              sx={{ backgroundColor: 'white' }}
              InputProps={{
                endAdornment:
                <InputAdornment position="end">
                                            <SearchIcon
                    onClick={handleSearchTM}
                    sx={{ cursor: 'pointer' }} />
                  
                                            <ClearIcon
                    onClick={handleCleanTM}
                    sx={{ cursor: 'pointer' }} />
                  
                                        </InputAdornment>

              }} />
              
                        </div>
                    </FormControl>
                </div>

                <br />

                <DataGridGenerico
          columns={columnsTM}
          rows={tecnologiasMedicas && tecnologiasMedicas.map((item, index) => {return { id: index + 1, ...item };})}
          toolbar={false}
          checkboxSelection={true}
          disableSelectionOnClick
          onRowSelectionModelChange={(ids) => onRowsSelectionHandlerDispo(ids)}
          rowSelectionModel={rowSelectionModelDispo}
          getRowId={(row) => row._id}
          totalCount={tecnologiasMedicas.length} />
        
            </CustomDialog>

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgProducto}
        title={'Selecciona Producto'}
        onCancel={handleCloseDlgProducto}
        cancelText='Cerrar'>
        
                <div style={{ display: 'flex', width: '100%' }}>
                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <div style={{ display: 'flex', width: '100%' }}>
                            <TextField
                label="Filtrar"
                name="txtFiltroProducto"
                size="small"
                type="text"
                variant="outlined"
                inputRef={txtFiltroProducto}
                onKeyUp={handleSearchProducto}
                sx={{ backgroundColor: 'white' }}
                InputProps={{
                  endAdornment:
                  <InputAdornment position="end">
                                            <SearchIcon
                      onClick={handleSearchProducto}
                      sx={{ cursor: 'pointer' }} />
                    
                                            <ClearIcon
                      onClick={handleCleanProducto}
                      sx={{ cursor: 'pointer' }} />
                    
                                        </InputAdornment>

                }} />
              
                        </div>
                    </FormControl>
                </div>

                <br />

                <DataGridGenerico
          columns={columnsProducto}
          rows={productos}
          toolbar={false}
          onRowClick={handleRowClickProducto}
          totalCount={productos.length} />
        
            </CustomDialog>

        </>);

}